export default __webpack_public_path__ + "static/plant_with_pot-2c0f93bd65c7a51e9b01a16724f3a9c6.png";